// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"619":"496a0cb1","937":"13fa398e"}[chunkId] + ".chunk.js";
};